import { userStatusTranslation } from "@/common/constants/userStatus.constant"
import LastConsumptionDetails from "@/features/privateCompanies/components/LastConsumptionDetails";
import { CompanyUserData } from "@/features/privateCompanies/types/companyUsers.type"
import { ArrowBigRight, UserRoundIcon } from "lucide-react"
import { createElement } from "react";
import { Link } from "react-router-dom"
import Button from "../components/Button";
import ImageWithDisplayName from "../components/ImageWithDisplayName";
import { formatDateTime } from "@/common/utils/formatters";

export class CompanyUsersTransformer {
  static tableTransformer({ companyId, operationKlassToCheckPermission }: { companyId: string; operationKlassToCheckPermission?: string }) {
    return (companyUsers: CompanyUserData[]) => {
      return companyUsers.map((companyUser) => ({
        ...companyUser,
        full_name_with_profile_picture: (
          <ImageWithDisplayName
            placeholderIcon={UserRoundIcon}
            imageUrl={companyUser.profile_picture?.url}
            displayName={companyUser.full_name}
          />
        ),
        user_role: !!companyUser?.user_roles?.length ? (companyUser?.user_roles?.map((userRole) => userRole.role.display_name).join(', ') || 'Não informado') : 'Não informado',
        branch_name: companyUser?.branch ? companyUser?.branch?.display_name : 'Não informado',
        lastSeenAt: companyUser?.last_seen_at ? formatDateTime(new Date(companyUser?.last_seen_at)) : "",
        status: userStatusTranslation[(companyUser?.status || 'default') as keyof typeof userStatusTranslation],
        LastConsumption: companyUser.last_consumption ? createElement(LastConsumptionDetails, { lastConsumption: companyUser.last_consumption }) : '--',
        actions: <Link to={`/companies/${companyId}/users/${companyUser.id}`}>
          <Button name="access_company_user" className="bg-transparent hover:bg-transparent p-0" operationKlassToCheckPermission={operationKlassToCheckPermission}>
            <ArrowBigRight />
          </Button>
        </Link>
      }))
    }
  }

  static quickSearchModelTransformer() {
    return (users: CompanyUserData[]) => {
      return users.map((user) => ({
        route: `companies/${user.company_id}/users/${user.id}`,
        items: [
          ['Perfil', !!user?.user_roles?.length && (user?.user_roles?.map((userRole) => userRole.role.display_name).join(', '))],
          ['Nome', user.full_name],
          ['Empresa', user?.branch?.general_information?.fantasy_name],
          ['Filial', user?.branch?.display_name],
        ],
      }));
    };
  }
}
